module.exports = __webpack_public_path__ + "static/media/environmental-small.bf098399.mp4";